import Tab from 'bootstrap/js/src/tab';

window.BootstrapTab = Tab;
